<div class="agent-container">
  <div class="agent-list-panel">
    <div class="search-bar-container">
      <button mat-raised-button color="primary" (click)="createNewAgent()">
        <mat-icon>add</mat-icon>
        New
      </button>
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search agents</mat-label>
        <input matInput [(ngModel)]="searchQuery" (ngModelChange)="filterAgents()" placeholder="Search by name or description">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </div>

    <div class="agents-list">
      <mat-card *ngFor="let agent of filteredAgents" 
                [class.selected]="selectedAgent?._id === agent._id"
                (click)="selectAgent(agent)">
        <mat-card-header>
          <mat-card-title>
            <span *ngIf="agent.isBuiltIn" class="built-in-star" matTooltip="This is a built in agent">*</span>
            {{agent.name}}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{agent.description}}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="agent-details" *ngIf="selectedAgent || isCreatingNew">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{isCreatingNew ? 'Create Agent' : 'Edit Agent'}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="agentForm" (ngSubmit)="isCreatingNew ? createAgent() : updateAgent()">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" [readonly]="!isCreatingNew">
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" rows="3"></textarea>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>LLM Vendor</mat-label>
            <mat-select formControlName="llmVendor">
              <mat-option *ngFor="let vendor of vendors" [value]="vendor">
                {{vendor}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width">
            <mat-label>LLM Model</mat-label>
            <mat-select formControlName="llmModel" [disabled]="!agentForm.get('llmVendor').value">
              <mat-option *ngFor="let model of models[agentForm.get('llmVendor').value] || []" [value]="model">
                {{model}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="full-width" style="position: relative;">
            <mat-label>System Prompt</mat-label>
            <textarea matInput formControlName="systemPrompt" rows="4"></textarea>
            <button mat-icon-button type="button" style="position: absolute; top: 8px; right: 8px; z-index: 2;" (click)="openSystemPromptModal()" matTooltip="Show Markdown Preview">
              <mat-icon>visibility</mat-icon>
            </button>
          </mat-form-field>

          <div class="form-row">
            <mat-form-field appearance="fill" class="half-width">
              <mat-label>Top P</mat-label>
              <input matInput type="number" formControlName="topP">
            </mat-form-field>

            <mat-form-field appearance="fill" class="half-width">
              <mat-label>Temperature</mat-label>
              <input matInput type="number" formControlName="temperature" min="0" max="2" step="0.1">
              <mat-hint>Value between 0 and 2</mat-hint>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="fill" class="half-width">
              <mat-label>Max Prompt Tokens</mat-label>
              <input matInput type="number" formControlName="maxPromptTokens" min="1">
              <mat-hint>Maximum number of tokens for the prompt</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="fill" class="half-width">
              <mat-label>Max Completion Tokens</mat-label>
              <input matInput type="number" formControlName="maxCompletionTokens" min="1">
              <mat-hint>Maximum number of tokens for the completion</mat-hint>
            </mat-form-field>
          </div>

          <div class="form-row">
            <div fxFlex="50%">
              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Vector Store ID</mat-label>
                <input matInput formControlName="vectorStoreId">
              </mat-form-field>

              <mat-form-field appearance="fill" class="full-width">
                <mat-label>Vendor Assistant ID</mat-label>
                <input matInput formControlName="vendorAssistantId">
              </mat-form-field>
    
              <div class="checkbox-group">
                <mat-checkbox formControlName="promptCache">
                  Prompt Caching
                </mat-checkbox>

                <mat-checkbox formControlName="vendorAssistantIsShared">
                  Vendor Assistant Is Shared
                </mat-checkbox>
    
                <mat-checkbox formControlName="vectorStoreIsShared">
                  Vector Store Is Shared
                </mat-checkbox>
    
                <mat-checkbox formControlName="asTool">
                  As Tool
                </mat-checkbox>

                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Context Compact</mat-label>
                  <mat-select formControlName="contextCompact">
                    <mat-option value="none">None</mat-option>
                    <mat-option value="auto">Auto</mat-option>
                    <mat-option value="custom">Custom</mat-option>
                    <mat-option value="no-memory">No Memory</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-checkbox formControlName="manualUpdate">
                  Manual Update
                </mat-checkbox>

                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Template Keys</mat-label>
                  <input matInput formControlName="templateKeys" placeholder="key1,key2,key3">
                  <mat-hint>Comma-separated list of template keys</mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="50%">
              <div class="tools-header">
                <h3>Tools</h3>
                <button mat-icon-button color="primary" (click)="addTool($event)" [matTooltip]="'Add Tool'">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
              
              <div class="tools-list">
                <mat-form-field appearance="fill" class="full-width" *ngFor="let tool of agentForm.get('tools').value; let i = index">
                  <mat-label>Tool {{i + 1}}</mat-label>
                  <mat-select [(ngModel)]="agentForm.get('tools').value[i]" [ngModelOptions]="{standalone: true}" 
                            (ngModelChange)="updateTools()">
                    <mat-option *ngFor="let availableTool of tools" [value]="availableTool._id"
                              [matTooltip]="availableTool.description">
                      {{availableTool.name}}
                    </mat-option>
                  </mat-select>
                  <button mat-icon-button matSuffix color="warn" (click)="removeTool(i)" [matTooltip]="'Remove Tool'">
                    <mat-icon>remove</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="form-row">
            <mat-form-field appearance="fill" class="half-width">
              <mat-label>Tool Choice</mat-label>
              <mat-select formControlName="toolChoice">
                <mat-option value="none">None</mat-option>
                <mat-option value="auto">Auto</mat-option>
                <mat-option value="required">Required</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="half-width">
              <mat-label>Reasoning Effort</mat-label>
              <mat-select formControlName="reasoningEffort">
                <mat-option [value]="null">Unspecified</mat-option>
                <mat-option value="minimal">minimal</mat-option>
                <mat-option value="low">low</mat-option>
                <mat-option value="medium">medium</mat-option>
                <mat-option value="high">high</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="form-actions" fxLayoutGap="10px">
            <button mat-raised-button color="warn" type="button" (click)="deleteAgent()" [disabled]="isCreatingNew">
              Delete Agent
            </button>
            <button mat-raised-button color="primary" type="submit" [disabled]="!agentForm.valid || (!isCreatingNew && !agentForm.dirty)">
              {{isCreatingNew ? 'Create Agent' : 'Update Agent'}}
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- <div class="file-uploader">
  <input type="file" (change)="onFileSelected($event)" #fileInput style="display: none;">
  <button mat-raised-button color="primary" (click)="fileInput.click()">
    <mat-icon>attach_file</mat-icon>
    Choose File
  </button>
</div>

<p className="text-[#E70F96] text-[91px] font-['DM_Sans'] font-bold col-span-9">The 91/90/-3% </p> -->
